<template>
  <div class="breathing-guide">
    <div class="gauge-container">
      <!-- Texte de phase au-dessus du tube -->
      <div class="breath-phase">{{ currentPhase }}</div>

      <div class="gauge">
        <div class="gauge-bar" :style="gaugeStyle"></div>
      </div>

      <!-- Bouton de réglage placé en bas à droite avec taille réduite -->
      <button @click="openModal = true" class="settings-button">
        <i class="fa fa-cog"></i>
      </button>
    </div>

    <!-- Panneau de paramètres (modal) -->
    <div v-if="openModal">
      <div class="modal-background" @click="openModal = false"></div>
      <div class="modal-content">
        <!-- Croix pour fermer la modale -->
        <button class="close-button" @click="openModal = false">&times;</button>

        <!-- Champ de sélection "CPM" -->
        <label>CPM</label>
        <br />
        <select v-model="cpm" @change="updateBreathingPattern">
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="10">10</option>
          <option value="12">12</option>
        </select>
        <br />
        <!-- Champ de sélection "Profile" -->
        <label>Profile</label>
        <br />
        <select v-model="profile" @change="updateBreathingPattern">
          <option value="profonde">Profonde</option>
          <option value="tonique">Tonique</option>
          <option value="basique">Basique</option>
        </select>
        <br />

        <!-- Inspiration et Expiration -->
        <div class="row-cpm">
          <div class="column-cpm">
            <!-- Champ de chiffres "Inspiration" -->
            <label>Inspiration</label>
            <div class="input-container">
              <!-- Bouton "moins" -->
              <button
                v-bind:class="{
                  disabled: inspiration === 0,
                  'opacity-50': inspiration === 0,
                }"
                class="minus-button"
                @click="
                  inspiration = parseFloat((inspiration - 0.1).toFixed(1))
                "
              >
                -
              </button>
              <!-- Champ de chiffres -->
              <input
                readonly
                type="number"
                v-model="inspiration"
                class="input"
                step="0.1"
              />

              <!-- Bouton "plus" -->
              <button
                class="plus-button"
                @click="
                  inspiration = parseFloat((inspiration + 0.1).toFixed(1))
                "
              >
                +
              </button>
            </div>
          </div>

          <div class="column-cpm">
            <!-- Champ de chiffres "Expiration" -->
            <label>Expiration</label>
            <div class="input-container">
              <!-- Bouton "moins" -->
              <button
                v-bind:class="{
                  disabled: expiration === 0,
                  'opacity-50': expiration === 0,
                }"
                class="minus-button"
                @click="expiration = parseFloat((expiration - 0.1).toFixed(1))"
              >
                -
              </button>
              <!-- Champ de chiffres -->
              <input
                readonly
                type="number"
                v-model="expiration"
                class="input"
                step="0.1"
              />

              <!-- Bouton "plus" -->
              <button
                class="plus-button"
                @click="expiration = parseFloat((expiration + 0.1).toFixed(1))"
              >
                +
              </button>
            </div>
          </div>
        </div>

        <!-- Pause Inspiration et Pause Expiration -->
        <div class="row-cpm">
          <div class="column-cpm">
            <!-- Champ de chiffres "Pause inspiration" -->
            <label>Pause inspiration</label>
            <div class="input-container">
              <!-- Bouton "moins" -->
              <button
                v-bind:class="{
                  disabled: pauseInspiration === 0,
                  'opacity-50': pauseInspiration === 0,
                }"
                class="minus-button"
                @click="
                  pauseInspiration = parseFloat(
                    (pauseInspiration - 0.1).toFixed(1)
                  )
                "
              >
                -
              </button>
              <!-- Champ de chiffres -->
              <input
                readonly
                type="number"
                v-model="pauseInspiration"
                class="input"
                step="0.1"
              />

              <!-- Bouton "plus" -->
              <button
                class="plus-button"
                @click="
                  pauseInspiration = parseFloat(
                    (pauseInspiration + 0.1).toFixed(1)
                  )
                "
              >
                +
              </button>
            </div>
          </div>

          <div class="column-cpm">
            <!-- Champ de chiffres "Pause expiration" -->
            <label>Pause expiration</label>
            <div class="input-container">
              <!-- Bouton "moins" -->
              <button
                v-bind:class="{
                  disabled: pauseExpiration === 0,
                  'opacity-50': pauseExpiration === 0,
                }"
                class="minus-button"
                @click="
                  pauseExpiration = parseFloat(
                    (pauseExpiration - 0.1).toFixed(1)
                  )
                "
              >
                -
              </button>
              <!-- Champ de chiffres -->
              <input
                readonly
                type="number"
                v-model="pauseExpiration"
                class="input"
                step="0.1"
              />

              <!-- Bouton "plus" -->
              <button
                class="plus-button"
                @click="
                  pauseExpiration = parseFloat(
                    (pauseExpiration + 0.1).toFixed(1)
                  )
                "
              >
                +
              </button>
            </div>
          </div>
        </div>

        <div class="buttons-container">
           <button
            @click="recupDataCPM()"
            class="buttonChart"
            style="background-color: rgb(35, 147, 128); color: white"
          >
            Récupérer mes paramètres personnels
          </button>
          <button
            @click="SaveDataCPM()"
            class="buttonChart"
            style="background-color: rgb(35, 147, 128); color: white"
          >
            Enregistrer mes paramètres personnels
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Parse from "parse";

export default {
  name: "BreathingGuide",
  props: {
    idUserForSave: String,
    idPatientTherapeute: String,
  },
  data() {
    return {
      openModal: false,
      cpm: 6,
      profile: "basique",
      inspiration: 4.5,
      expiration: 5.5,
      pauseInspiration: 0,
      pauseExpiration: 0,
      currentPhase: "Inspirez",
      phaseInterval: null,
      UtilisateurCPM: null,
    };
  },
  computed: {
    animationDuration() {
      return (
        this.inspiration +
        this.pauseInspiration +
        this.expiration +
        this.pauseExpiration
      );
    },
    gaugeStyle() {
      return {
        animation: `breathing ${this.animationDuration}s infinite cubic-bezier(0.4, 0, 0.2, 1)`,
      };
    },
  },
  methods: {
    recupDataCPM() {
      var data = Parse.Object.extend("user_param_game");
      var query = new Parse.Query(data);
      var objectUser = Parse.Object.extend("User");
      var queryUser = new Parse.Query(objectUser);
      queryUser.equalTo("objectId", Parse.User.current().id);
      query.matchesQuery("user", queryUser);

      query.first().then((result) => {
        if (result) {
          var data_cpm = result.attributes.paramJeux;
          data_cpm = JSON.parse(data_cpm);
          this.inspiration = data_cpm.Inspi;
          this.expiration = data_cpm.Expi;
          this.pauseInspiration = data_cpm.InspiPause;
          this.pauseExpiration = data_cpm.ExpiPause;
          this.updateAnimation();
        }
      });
    },
    async SaveDataCPM() {
      this.openModal = false;
      var data_cpm = {
        Inspi: this.inspiration,
        Expi: this.expiration,
        InspiPause: this.pauseInspiration,
        ExpiPause: this.pauseExpiration,
      };
      data_cpm = JSON.stringify(data_cpm);
      var user = Parse.User.current();
      const Data = Parse.Object.extend("user_param_game");
      const DataUser = Parse.Object.extend("User");
      const queryUser = new Parse.Query(DataUser);
      const query = new Parse.Query(Data);
      if (this.idUserForSave) {
        queryUser.equalTo("objectId", this.idUserForSave);
        const [user_cpm] = await Promise.all([queryUser.find()]);
        this.UtilisateurCPM = user_cpm[0];
        query.equalTo("user", this.UtilisateurCPM);
      } else if (this.idPatientTherapeute) {
        queryUser.equalTo("objectId", this.idPatientTherapeute);
        const [user_cpm] = await Promise.all([queryUser.find()]);
        this.UtilisateurCPM = user_cpm[0];
        query.equalTo("user", this.UtilisateurCPM);
      } else {
        query.equalTo("user", user);
        this.UtilisateurCPM = user;
      }
      query
        .first()
        .then((result) => {
          if (result) {
            result.set("paramJeux", data_cpm);
            return result.save();
          } else {
            const data = { user: this.UtilisateurCPM, paramJeux: data_cpm };
            const dataDone = new Data();
            return dataDone.save(data);
          }
        })
        .then(
          () => {
            console.log("Data saved successfully");
            this.updateAnimation();
          },
          (error) => {
            console.error("Error while saving Data: ", error);
          }
        );
    },
    applySettings() {
      this.openModal = false;
      this.updateAnimation();
    },
    updateBreathingPattern() {
      const cpm = Number(this.cpm);
      if (cpm === 5) {
        if (this.profile === "basique") {
          this.inspiration = 5.4;
          this.expiration = 6.6;
        } else if (this.profile === "tonique") {
          this.inspiration = 6;
          this.expiration = 6;
        } else if (this.profile === "profonde") {
          this.inspiration = 4.8;
          this.expiration = 7.2;
        }
      } else if (cpm === 6) {
        if (this.profile === "basique") {
          this.inspiration = 4.5;
          this.expiration = 5.5;
        } else if (this.profile === "tonique") {
          this.inspiration = 5;
          this.expiration = 5;
        } else if (this.profile === "profonde") {
          this.inspiration = 4;
          this.expiration = 6;
        }
      } else if (cpm === 7) {
        if (this.profile === "basique") {
          this.inspiration = 4.29;
          this.expiration = 4.29;
        } else if (this.profile === "tonique") {
          this.inspiration = 3.86;
          this.expiration = 4.71;
        } else if (this.profile === "profonde") {
          this.inspiration = 3.43;
          this.expiration = 5.14;
        }
      } else if (cpm === 8) {
        if (this.profile === "basique") {
          this.inspiration = 3.38;
          this.expiration = 4.13;
        } else if (this.profile === "tonique") {
          this.inspiration = 3.75;
          this.expiration = 3.75;
        } else if (this.profile === "profonde") {
          this.inspiration = 3;
          this.expiration = 4.5;
        }
      } else if (cpm === 10) {
        if (this.profile === "basique") {
          this.inspiration = 2.7;
          this.expiration = 3.3;
        } else if (this.profile === "tonique") {
          this.inspiration = 3;
          this.expiration = 3;
        } else if (this.profile === "profonde") {
          this.inspiration = 2.4;
          this.expiration = 3.6;
        }
      } else if (cpm === 12) {
        if (this.profile === "basique") {
          this.inspiration = 2.7;
          this.expiration = 3.3;
        } else if (this.profile === "tonique") {
          this.inspiration = 2.5;
          this.expiration = 2.5;
        } else if (this.profile === "profonde") {
          this.inspiration = 2;
          this.expiration = 3;
        }
      }
    },
    updateAnimation() {
      const oldStyle = document.getElementById("breathing-animation-style");
      if (oldStyle) {
        document.head.removeChild(oldStyle);
      }

      const keyframes = `
        @keyframes breathing {
          0% {
            height: 0%;
            background-color: #64b5f6;
          }
          ${(this.inspiration / this.animationDuration) * 100}% {
            height: 100%;
            background-color: #2196f3;
          }
          ${
            ((this.inspiration + this.pauseInspiration) /
              this.animationDuration) *
            100
          }% {
            height: 100%;
            background-color: #1976d2;
          }
          ${
            ((this.inspiration + this.pauseInspiration + this.expiration) /
              this.animationDuration) *
            100
          }% {
            height: 0%;
            background-color: #64b5f6;
          }
          100% {
            height: 0%;
            background-color: #64b5f6;
          }
        }
      `;

      const style = document.createElement("style");
      style.id = "breathing-animation-style";
      style.textContent = keyframes;
      document.head.appendChild(style);

      this.startPhaseWatcher();
    },
    startPhaseWatcher() {
      if (this.phaseInterval) clearInterval(this.phaseInterval);

      const checkInterval = 100; // ms
      let elapsedTime = 0;

      this.phaseInterval = setInterval(() => {
        elapsedTime =
          (elapsedTime + checkInterval / 1000) % this.animationDuration;

        if (elapsedTime < this.inspiration) {
          this.currentPhase = "Inspirez";
        } else if (elapsedTime < this.inspiration + this.pauseInspiration) {
          this.currentPhase = "Tenez";
        } else if (
          elapsedTime <
          this.inspiration + this.pauseInspiration + this.expiration
        ) {
          this.currentPhase = "Expirez";
        } else {
          this.currentPhase = "Pause";
        }
      }, checkInterval);
    },
  },
  mounted() {
    // this.recupDataCPM();
    this.updateBreathingPattern();
    this.updateAnimation();
  },
  beforeDestroy() {
    if (this.phaseInterval) clearInterval(this.phaseInterval);

    const style = document.getElementById("breathing-animation-style");
    if (style) {
      document.head.removeChild(style);
    }
  },
};
</script>

<style scoped>
.breathing-guide {
  border-radius: 8px;
  padding: 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.gauge-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  flex: 1;
  margin-top: 20px;
}

.gauge {
  position: relative;
  width: 60px;
  height: 180px;
  background-color: #eee;
  border-radius: 15px 15px 0 0;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.gauge-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 0;
  background-color: #2196f3;
  border-radius: 15px 15px 0 0;
  transition: height linear;
}

.breath-phase {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 15px;
}

.settings-button {
  position: absolute;
  bottom: -10px;
  right: -10px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: #489181;
  color: white;
  border: none;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  z-index: 5;
}

.settings-button:hover {
  background-color: #397870;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
}

.modal-background {
  z-index: 1100;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  z-index: 1110;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border-radius: 15px;
  width: 90%;
  max-width: 500px;
}

.close-button {
  position: absolute;
  top: 0;
  right: 0;
  margin: 10px;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  color: black;
  background: none;
  border: none;
}
.row-cpm {
  display: flex;
  margin-bottom: 1rem;
  gap: 1rem;
}

.column-cpm {
  flex: 1;
}

.input-container {
  display: flex;
  align-items: center;
}

.input {
  flex: 1;
  height: 30px;
  font-size: 16px;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  -moz-appearance: textfield;
  -webkit-appearance: none;
  appearance: none;
  margin: 0 5px;
}

.plus-button,
.minus-button {
  width: 30px;
  height: 30px;
  font-size: 14px;
  font-weight: bold;
  color: white;
  background-color: rgb(35, 147, 128);
  border: none;
  cursor: pointer;
  border-radius: 4px;
}

.plus-button.disabled,
.minus-button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.buttons-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 1.5rem;
}

.buttonChart {
    padding: 10px 20px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
}

select {
  width: 100%;
  height: 30px;
  font-size: 16px;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  -moz-appearance: textfield;
}
</style>
